import Joi from "joi";

export const ticketFeedbackSchema = Joi.object({
  comment: Joi.string().allow("", null).label("Comment"),
  objectId: Joi.string().min(2).label("Ticket Id"),
});
